export const environment = {
  production: false,
   backendUrl:'https://dev.hecbill.hecticus.com'
  // backendUrl:'https://dev.hecbill.hecticus.com'
  //backendUrl:'https://dev.hecbill.hecticus.com'
  // backendUrl:'https://dev.hecbill.hecticus.com'

};
